import { values } from "@omni/utils/object.utils";

import { ModalId, ModalType } from "@/redux/modules/value/modal/modal.types";

export const getModalId = (
    type?: ModalType,
    descriminator?: string
): ModalId | undefined => {
    if (!type) return undefined;

    return descriminator ? `${type}-${descriminator}` : type;
};

export const isModalId = (str: string): str is ModalId => {
    if (!str) return false;

    return values(ModalType).some((modalType) => {
        return str.startsWith(modalType);
    });
};
